import { Tooltip } from "@mui/material";
import { GridColumns } from "@mui/x-data-grid";
import { TableDateHelper } from "../../../Component/Model/helpers";

export module BEEUserScorecardDataGrid {
    export const columns: GridColumns = [
        {
            field: "Name", headerName: "Scorecard Name", flex: 1, minWidth: 250,
            renderCell: (params: any) => (
                <Tooltip title={params.value}>
                    <span style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}>{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "ScorecardTypeName", headerName: "Type", flex: 1, minWidth: 300, width: 300,
            renderCell: (params: any) => (
                <Tooltip title={params.value}>
                    <span style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}>{params.value}</span>
                </Tooltip >
            ),
        },
        { field: "StartDate", headerName: "Start Date", flex: 1, minWidth: 130, type: 'date', valueGetter: ({ value }) => value && new Date(value), },
        { field: "EndDate", headerName: "End Date", flex: 1, minWidth: 130, type: 'date', valueGetter: ({ value }) => value && new Date(value), },
        { field: "RatingLevel", headerName: "BEE Level", flex: 1, minWidth: 130 },
        {
            field: "TotalPoints", headerName: "Total Points", flex: 1, minWidth: 100,
            renderCell: (params: any) => (
                <span>{Number(params.value).toFixed(2)}</span>
            ),
        },
        { field: "CreatedDate", headerName: "Date Created", flex: 1, minWidth: 130, type: 'date', valueGetter: ({ value }) => value && new Date(value), },
        { field: "LicenseExpiryDate", headerName: "License Expiry Date", flex: 1, minWidth: 130, type: 'date', valueGetter: ({ value }) => value && new Date(value), },
    ];
}

export module EEUserScorecardDataGrid {
    export const columns: GridColumns = [
        {
            field: "Name", headerName: "Scorecard Name", flex: 1, minWidth: 250,
            renderCell: (params: any) => (
                <Tooltip title={params.value}>
                    <span style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}>{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "ScorecardTypeName", headerName: "Type", flex: 1, minWidth: 300, width: 300,
            renderCell: (params: any) => (
                <Tooltip title={params.value}>
                    <span style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}>{params.value}</span>
                </Tooltip >
            ),
        },
        { field: "StartDate", headerName: "Start Date", flex: 1, minWidth: 130, type: 'date', valueGetter: ({ value }) => value && TableDateHelper(value), },
        { field: "EndDate", headerName: "End Date", flex: 1, minWidth: 130, type: 'date', valueGetter: ({ value }) => value && TableDateHelper(value), },
        { field: "CreatedDate", headerName: "Date Created", flex: 1, minWidth: 130, type: 'date', valueGetter: ({ value }) => value && TableDateHelper(value), },
        { field: "LicenseExpiryDate", headerName: "License Expiry Date", flex: 1, minWidth: 130, type: 'date', valueGetter: ({ value }) => TableDateHelper(value), },
    ];
}